
import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router, UrlSegment, Params } from '@angular/router';
import { Breadcrumb } from '../../models/breadcrumb';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

const initialBreadcrumb: Breadcrumb = {
  label: '',
  url: '',
  dynamicLabel: ''
};

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService implements OnDestroy {

  public breadcrumbs = new BehaviorSubject<Breadcrumb[]>([initialBreadcrumb]);
  private unsubscribe: Subject<void> = new Subject();
  private previousRouteQueryParams: Params;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((event) => {

      const root: ActivatedRoute = this.activatedRoute.root;
      const breadCrumbs: Breadcrumb[] = this.getBreadcrumbs(root);
      this.breadcrumbs.next(breadCrumbs);
    });
  }


  private getBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

    // get the child routes
    const children: ActivatedRoute[] = route.children;

    // return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    // iterate over children
    for (const child of children) {
      // verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      // verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      // remove last element from array
      // let lastElement : UrlSegment =  child.snapshot.url.pop();
      child.snapshot.url.filter(e => e.path !== 'itm' && e.path !== 'info' && e.path !== 'page').map(segment => {
        url += `/${segment.path}`;

        const breadcrumb: Breadcrumb = {
          label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
          url: url, // full url including all previous segments
          dynamicLabel : this.getDynamicLabel(segment.path),
          params: child.snapshot.params,
          queryParams : this.previousRouteQueryParams
        };
        breadcrumbs.push(breadcrumb);
      });

      this.previousRouteQueryParams = child.snapshot.queryParams;
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
  }

  private getDynamicLabel(segmentPath): string {
    if (segmentPath) {
      const segmentPathAsWordArray = segmentPath.split('-');
      let dynamicLabel = '';
      let  firstLetter = true;
      for (let word of segmentPathAsWordArray) {
        if (firstLetter ) { // ovde puca error
          if ( word && word[0]) {
            word = word[0].toUpperCase() + word.substr(1);
            firstLetter = false;
          } else {
            return 'back';
          }
        }
        dynamicLabel += ' ' + word;
      }
      return dynamicLabel;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
